var popup = {
    el: {},

    data: {
        currentPopup: [],
    },

    init: function(settings) {
        var _this = this;

        _this.bindUIActions();
        if (settings) {
            _this.data.settings = settings;
        }

        //Check URL for poup id
        if (window.location.hash) {
            _this.open(window.location.hash.replace("#", ""));
        }
    },

    bindUIActions: function() {
        var _this = this;

        //When clicked on opener
        $(document).on("click", '[data-popup]', function() {
            if ($(this).data('popup')) {
                _this.open($(this).data('popup'));
            } else {
                alert('Please provide popup Id.');
            }
        });

        //When clicked on close
        $(document).on("click", '.popup__close', function(e) {
            var $if = $(e.delegateTarget).find('iframe');
            var src = $if.attr("src");
            $if.attr("src", '/empty.html');
            $if.attr("src", src);
            _this.close($(this).parents('.popup').attr('id'));
        });

        //Clicked outside popup
        $(document).mouseup(function(e) {
            if (_this.data.currentPopup.length > 0) {
                var container = $('.popup__wrap');
                if (!container.is(e.target) && container.has(e.target).length === 0) {
                    var $if = $(e.delegateTarget).find('iframe');
                    var src = $if.attr("src");
                    $if.attr("src", '/empty.html');
                    $if.attr("src", src);
                    _this.close();
                }
            }
        });

        //Key Up
        $(document).keyup(function(e) {
            if (_this.data.currentPopup.length > 0) {
                if (e.keyCode == 27) {
                    _this.close();
                }
            }
        });
    },

    open: function(popupID) {
        var _this = this;
        var popupObj = $('#' + popupID);
        if (popupObj.length > 0) {
            _this.data.currentPopup.push(popupID);
            popupObj.css('z-index', 99 + _this.data.currentPopup.length).addClass('open');
            popupObj.find('.popup_focus').focus();

            $('body').addClass('popup__is-open');

            if (_this.data.settings && _this.data.settings.afterOpen) {
                _this.data.settings.afterOpen(popupID);
            }
        }
    },

    close: function(popupID) {
        var _this = this;
        //If popupid is not defined set the last opened popup
        if (!popupID) {
            popupID = _this.data.currentPopup[_this.data.currentPopup.length - 1];
        }
        var popupObj = $('#' + popupID);
        if (popupObj.length > 0) {
            var popupIndex = _this.data.currentPopup.indexOf(popupID);
            _this.data.currentPopup.splice(popupIndex, 1);
            popupObj.removeClass('open');
            //popupObj.removeClass('open').css('z-index',-1);

            $('body').removeClass('popup__is-open');

            if (_this.data.settings && _this.data.settings.afterClose) {
                _this.data.settings.afterClose(popupID);
            }
        } else {
            alert('Popup Not Found!');
        }
    },
};
$(document).ready(function() {

    popup.init();

    $('ul.tabs-list li').click(function() {
        var tab_id = $(this).attr('data-tab');

        $('ul.tabs-list li').removeClass('current');
        $('.tab-content').removeClass('current');

        $(this).addClass('current');
        $("#" + tab_id).addClass('current');
    });

    $(".tabs li a").click(function() {

        // Active state for tabs
        $(".tabs li a").removeClass("active");
        $(this).addClass("active");

        // Active state for Tabs Content
        $(".tab_content_container > .tab_content_active").removeClass("tab_content_active").fadeOut(200);
        $(this.rel).fadeIn(500).addClass("tab_content_active");

    });
    $('.review-slider').slick({
      dots: true,
      arrows: false,
      
      autoplay: true,
      autoplaySpeed: 2000,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
	});
			
});

// YOUTUBE IFRAME DEFER JAVASCRIPT

function init() {
    var vidDefer = document.getElementsByTagName("iframe");
    for (var i = 0; i < vidDefer.length; i++) {
        if (vidDefer[i].getAttribute("data-src")) {
            vidDefer[i].setAttribute("src", vidDefer[i].getAttribute("data-src"));
        }
    }
}
window.onload = init;